import { render } from "./PreloaderElement.vue?vue&type=template&id=78b30bbe&scoped=true"
import script from "./PreloaderElement.vue?vue&type=script&lang=js"
export * from "./PreloaderElement.vue?vue&type=script&lang=js"

import "./PreloaderElement.vue?vue&type=style&index=0&id=78b30bbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b30bbe"]])

export default __exports__